import { render, staticRenderFns } from "./EpisodeList.vue?vue&type=template&id=5d6840bc&scoped=true&"
import script from "./EpisodeList.vue?vue&type=script&lang=js&"
export * from "./EpisodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6840bc",
  null
  
)

export default component.exports